<template>
	<div class="slide slide_hero creator-store-panel">
		<div class="flex">
			<div id="big">
				<p class="referral-shoutout" v-if="referrerName">Exclusive Offer for Followers of {{ referrerName }} 🎁</p>
				<h1 class="anim">{{ header }}</h1>
				<h3 class="anim">
					{{ subHeader }}
				</h3>
				<TrialButton :show-button-caption="false" class="d-block" buttonClass="trial-btn" where-am-i="creator-store" />
			</div>
			<div id="hero" v-if="!replaceHero">
				<img id="hero_phone_1" class="hero_phone" src="@/assets/images/home/v6/stan-hero-1.png" />
				<img id="hero_phone_2" class="hero_phone" :src="heroPhoneImageSrc" />
				<img id="hero_bubble_1" class="hero_bubble" src="@/assets/images/home/v6/stan-hero-8.png" />
				<img id="hero_bubble_2" class="hero_bubble" src="@/assets/images/home/v6/stan-hero-6.png" />
				<img id="hero_bubble_3" class="hero_bubble" src="@/assets/images/home/v6/stan-hero-7.png" />
				<img id="hero_card_1" class="hero_card" src="@/assets/images/home/v6/stan-hero-3.png" />
				<img id="hero_card_2" class="hero_card" src="@/assets/images/home/v6/stan-hero-4.png" />
				<img id="hero_card_3" class="hero_card" src="@/assets/images/home/v6/stan-hero-5.png" />
			</div>
			<div id="hero" v-else>
				<img id="hero_phone_2" class="hero_phone" :src="heroPhoneImageSrc" />
			</div>
		</div>
	</div>
</template>

<script setup>
	import { defineProps, onUnmounted } from 'vue'
	import TrialButton from '@/components/shared/TrialButton.vue'
	import defaultHeroImage from '@/assets/images/home/v6/stan-hero-2.png'

	let animationId

	const props = defineProps({
		id: {
			type: [String, Number],
		},
		header: {
			type: String,
			default: 'Meet Your All·in·One Creator Store',
		},
		subHeader: {
			type: String,
			default:
				'Stan is the easiest way to make money online. All of your courses, digital products, and bookings are now hosted within your link-in-bio.',
		},
		heroPhoneImageSrc: {
			type: String,
			default: defaultHeroImage,
		},
		referrerName: {
			type: String,
		},
		activeComponent: { type: Boolean },
		replaceHero: {
			type: Boolean,
			default: false,
		},
	})

	let ratio = 0

	let loop = () => {
		if (window.scrollY < window.innerHeight * 2) {
			ratio = window.scrollY / window.innerHeight
			document.body.style.setProperty('--parallax-1', ratio * 1.4 * -160 + 100 + 'px')
			document.body.style.setProperty('--parallax-2', ratio * 1.5 * -160 + 100 + 'px')
			document.body.style.setProperty('--parallax-3', ratio * 1.6 * -160 + 100 + 'px')
			document.body.style.setProperty('--parallax-4', ratio * 1 * -160 + 100 + 'px')
		}

		animationId = window.requestAnimationFrame(loop)
	}
	animationId = window.requestAnimationFrame(loop)

	onUnmounted(() => {
		if (animationId) {
			window.cancelAnimationFrame(animationId)
		}
	})
</script>

<style lang="scss" scoped>
	body {
		width: 100vw;
		overflow-x: hidden;
		overflow-y: visible;

		image-rendering: -webkit-optimize-contrast;
		--parallax-1: 0;
		--parallax-2: 0;
		--parallax-3: 0;
		--parallax-4: 0;
	}

	.creator-store-nav {
		width: 100vw;
	}

	#highlight {
		flex-direction: column;
		gap: 0;
		width: fit-content;
		position: relative;
		margin: 0 !important;
		padding: 0 !important;

		img {
			position: absolute;
			bottom: -10px;
			left: -10px;
			margin: 0;
			width: 360px;
		}
	}

	.flex {
		display: flex;
		justify-content: center !important;
		align-items: center;
		gap: 0;
		height: 90vh;
		flex-wrap: nowrap;
		width: 90%;
		.referral-shoutout {
			font-weight: 700;
			color: white;
			font-size: 20px;
			line-height: 20px;
		}
	}

	.slide {
		width: 100vw;
		padding: 0;

		background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="1440" height="802" viewBox="0 0 1440 802" fill="none"><script xmlns=""/><path d="M0 0H1440V703.445L0 802V0Z" fill="%236355FF"/><script xmlns=""/></svg>');
		background-position: center bottom;
		background-color: white;
		animation: fade 0.3s ease forwards;
		margin-top: var(--nav-margin, 60px);

		&::before {
			content: '';
			position: fixed;
			top: -100vh;
			left: 0;
			width: 100vw;
			height: 100vh;
			background: #6355ff;
		}
	}

	@keyframes fade {
		from {
			opacity: 0;
			transform: translateY(30px);
		}
		to {
			opacity: 1;
			transform: translateY(0px);
		}
	}

	.slide_hero {
		padding: 0;
		padding-bottom: 25px;
		width: 100vw;
		background-size: cover;
		background-position: center bottom;
		color: white;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		gap: 50px;

		#big {
			position: relative;
			right: 0;
			top: 0;
			flex: 1;
			max-width: max(700px, 30%);
			min-width: 500px;
			//margin-top: 80px;

			h1 {
				font-size: 72px;
				line-height: 100%;
				font-weight: 800;
				letter-spacing: -1.5px;
				margin: 0;
				margin-block: 30px;
				color: white;
				text-shadow: 0 5px 20px rgba(black, 0.1);
			}
			h3 {
				max-width: 490px;
				font-size: 18px;
				line-height: 130%;
				font-weight: 400;
				letter-spacing: 0.05px;
				margin: 0;
				margin-bottom: 40px;
				color: var(--stan-primary-soft-color);
			}
		}

		@media screen and (min-width: 767px) {
			#hero {
				position: relative;
				right: 0;
				top: 60px;
				max-width: 65%;
				width: 700px;
				aspect-ratio: 0.872;
				flex-shrink: 1;
				padding: 0;
				display: block;
				transform: translateY(-110px);

				@supports not (aspect-ratio: 0.872) {
					height: 0;
					padding-top: max(54%, 600px);
				}
				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					transform: translate(-50px, var(--parallax-1));
				}
				#referral_phone {
					width: auto;
					transform: translate(0px, var(--parallax-1));
				}

				// Phone
				#hero_phone_1 {
					transform: translate(0px, var(--parallax-4));
				}

				#hero_phone_2 {
					transform: translate(0px, var(--parallax-1));
				}

				// Card
				#hero_card_1 {
					transform: translate(0px, var(--parallax-2));
				}

				#hero_card_2 {
					transform: translate(0px, var(--parallax-2));
				}

				#hero_card_3 {
					transform: translate(0px, var(--parallax-1));
				}

				// Bubbles
				#hero_bubble_1 {
					transform: translate(0px, var(--parallax-2));
				}

				#hero_bubble_2 {
					transform: translate(0px, var(--parallax-2));
				}

				#hero_bubble_3 {
					transform: translate(0px, var(--parallax-1));
				}
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.slide_hero {
			#big {
				min-width: 300px;
				.referral-shoutout {
					font-size: 14px;
				}
				h1 {
					font-size: 60px;
				}
				h3 {
					font-size: 16px;
				}
			}
		}
		.trial-btn {
			font-size: 10px;
		}
	}
	@media screen and (max-width: 767px) {
		.flex {
			display: flex;
			flex-direction: column;
			justify-content: start;
			align-items: start;
			gap: 30px;
			flex: 1;
			width: 100%;
			margin: 0;
			overflow: hidden;
		}

		.slide {
			background: #ebedff;
			width: 100vw;
			padding: 50px 0 50px 0;
		}

		#highlight {
			img {
				width: 180px;
				left: -5px;
				bottom: -12px;
			}
		}

		.slide_hero {
			width: 100vw;
			height: 70vh;
			background: white;
			background-image: url('/public/images/home/v6/rect.svg');
			background-size: cover;
			background-position: center bottom;
			color: white;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			position: relative;
			overflow: hidden;

			#big {
				padding-inline: 20px;
				background-color: var(--stan-primary-primary-color);
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: flex-start;
				width: 100%;
				height: fit-content;
				flex-shrink: 0;
				max-width: 3000px;
				min-width: unset;

				.referral-shoutout {
					font-size: 14px;
				}
				h1 {
					font-size: 36px;
					line-height: 120%;
					font-weight: 700;
					letter-spacing: -0.2px;
					margin: 0;
					margin-bottom: 16px;
				}
				h3 {
					font-size: 15px;
					line-height: 140%;
					font-weight: 300;
					margin: 0;
					margin-bottom: 32px;
					color: var(--stan-primary-soft-color);
					width: 100%;
				}

				#cta {
					width: 100%;
					padding: 20px 0;
					border-radius: 100px;
					background: #30ffb4;
					color: #131f60;
					display: flex;
					justify-content: center;
					align-items: center;
					gap: 15px;
					transition: 0.2s ease !important;

					h2 {
						font-size: 20px;
						font-weight: 800;
						letter-spacing: 0px;
						margin: 0;
					}
					img {
						height: 18px;
					}
					&:hover {
						gap: 30px;
					}
				}
			}

			#hero {
				width: 100vw;
				aspect-ratio: 0.872;
				flex-shrink: 0;
				padding: 0;
				transform: translate(20px, 20px);
				pointer-events: none;
				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					pointer-events: none;
				}
				#referral_phone {
					width: auto;
					left: 112px;
					height: 90%;
				}
			}
		}
	}
</style>
